import { FileText, SquareCheckBig } from "lucide-react";
import { NotificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { MyplannActivityIcon } from "web_myplann/Shared/Icons";

export const NotificationType = {
	activity: "activity",
	task: "task",
	meetingRecord: "meetingRecord",
} as const;

export const useGetDataByType = (type: NotificationTypeEnum, color: string) => {
	switch (type) {
		case NotificationTypeEnum.MeetingRecord:
			return {
				icon: <FileText size={16} color={color} />,
				type: NotificationType.meetingRecord,
			};
		case NotificationTypeEnum.DocumentExpires:
		case NotificationTypeEnum.SetAdvisor:
		case NotificationTypeEnum.TaskShared:
		case NotificationTypeEnum.TaskEditTerm:
		case NotificationTypeEnum.TaskEditDescription:
		case NotificationTypeEnum.TaskAddWorkflow:
		case NotificationTypeEnum.TaskEditWorkflow:
		case NotificationTypeEnum.TaskDeleteWorkflow:
		case NotificationTypeEnum.TaskAddWorkflowItem:
		case NotificationTypeEnum.TaskEditWorkflowItem:
		case NotificationTypeEnum.TaskDeleteWorkflowItem:
		case NotificationTypeEnum.TaskResolveWorkflotItem:
		case NotificationTypeEnum.TaskTermNotice:
		case NotificationTypeEnum.TaskGroup:
			return {
				icon: <SquareCheckBig size={16} color={color} />,
				type: NotificationType.task,
			};
		case NotificationTypeEnum.ActivityShared:
		case NotificationTypeEnum.ActivityEditTerm:
		case NotificationTypeEnum.ActivityEditDescription:
		case NotificationTypeEnum.ActivityTermNotice:
		case NotificationTypeEnum.ActivityGroup:
			return {
				icon: <MyplannActivityIcon color={color} />,
				type: NotificationType.activity,
			};
		default:
			return {
				icon: <MyplannActivityIcon color={color} />,
				type: NotificationType.activity,
			};
	}
};
